/* eslint-disable max-len */
import React, { useState, useContext } from 'react';
import {
  bool as boolType,
  any,
  string as stringType,
} from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import {
  bool,
  extend,
  string,
  shape,
  QueryProvider,
  QueryContext,
  params
} from '@thd-nucleus/data-sources';
import {
  isAppliance,
  getLoyaltyMembershipInput,
  getDisplayProducts,
} from '../utils/helpers';
import { RecsProductPod } from './RecsProductPod';

const Wrapper = ({ children }) => children;
Wrapper.dataModel = extend({
  product: params({ itemId: string().isRequired() }).shape({
    dataSource: string()
  })
}, RecsProductPod);
const MoreLikeThis = (props) => {

  const { customer } = useContext(ExperienceContext);
  const { defaultVariables } = useContext(QueryContext) || {};

  const isB2BCustomer = customer?.type === 'b2b';

  const {
    data,
    scheme,
    storeId,
    hideATC,
    hideFavorites,
    hideBadge,
    membershipInformation,
    zipCode,
    hideSwatches,
    analyticsAnchorProductSku,
    parent,
    zoneName,
    zonePosition,
    podResults,
    brandTitleMaxLine,
    hideRating,
    noATCFulfillment,
    hidePrice
  } = props;

  const qtxDefaultVariables = {
    storeId,
    zipCode,
    installationServices: false,
    loyaltyMembershipInput: getLoyaltyMembershipInput(membershipInformation),
    skipFavoriteCount: !!isB2BCustomer,
    ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant === 'boolean' && {
      isBrandPricingPolicyCompliant: defaultVariables.current.isBrandPricingPolicyCompliant
    })
  };

  const { products } = data || {};

  const [filtered] = useState([]);
  const [isCategorySelected] = useState(false);

  let displayProducts = getDisplayProducts(isCategorySelected, filtered, products);

  return (
    <>
      {displayProducts?.length > 0 && (
        <QueryProvider
          dataSource={scheme}
          cacheKey={`${scheme}-recommendations-carousel`}
          defaultVariables={qtxDefaultVariables}
        >
          {displayProducts.map((dynamicProduct, idx) => {
            const { product } = dynamicProduct;
            const { itemId } = product;
            const { canonicalUrl } = product?.identifiers || {};
            const { preferredPriceFlag } = product.pricing;
            return (
              <Wrapper key={idx}>
                <RecsProductPod
                  itemId={itemId}
                  key={itemId}
                  position={idx}
                  storeId={storeId}
                  scheme={scheme}
                  anchorProduct={analyticsAnchorProductSku}
                  parent={parent}
                  zoneName={zoneName}
                  zonePosition={zonePosition}
                  podResults={podResults}
                  hideSwatches={hideSwatches}
                  hideFavorites={hideFavorites}
                  hideBadge={hideBadge}
                  hideATC={hideATC}
                  hidePrice={hidePrice}
                  hideRating={hideRating}
                  preferredPriceFlag={preferredPriceFlag}
                  brandTitleMaxLine={brandTitleMaxLine}
                  strategy={dynamicProduct?.strategy}
                  noATCFulfillment={isAppliance(product) ? false : noATCFulfillment}
                  url={canonicalUrl}
                />
              </Wrapper>
            );
          }
          )}
        </QueryProvider>
      )}
    </>
  );
};

const productModel = extend({}, {
  itemId: string(),
  dataSource: string()
}, RecsProductPod.dataModel.product);

export const wrappedProduct1 = shape({
  category: string(),
  description: string(),
  idEndDate: string(),
  idPromoDetails: string(),
  idStartDate: string(),
  strategy: string(),
  isAnchor: bool(),
  product: params({
    dataSource: string()
  })
    .shape(productModel),
  slot: shape({
    description: string(),
    isRequired: bool(),
    name: string()
  })
});
MoreLikeThis.dataModel = extend(Wrapper, wrappedProduct1);

MoreLikeThis.displayName = 'MoreLikeThis';

MoreLikeThis.propTypes = {
  ...RecsProductPod.propTypes,
  // eslint-disable-next-line react/forbid-prop-types
  data: any,
  scheme: stringType,
  storeId: stringType.isRequired,
  hideATC: boolType,
  hideFavorites: boolType,
  hideBadge: boolType,
  hideSwatches: boolType,
  analyticsAnchorProductSku: stringType,
  hideRating: boolType,
  noATCFulfillment: boolType,
  hidePrice: boolType,
};

MoreLikeThis.defaultProps = {
  scheme: 'drecs',
  data: null,
  hideBadge: false,
  hideATC: false,
  hideFavorites: true,
  hideSwatches: true,
  analyticsAnchorProductSku: '',
  hideRating: false,
  noATCFulfillment: true,
  hidePrice: false,
};

export { MoreLikeThis };
